export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/63be6d886170d40a9f7900a9c2ee1f30.png";